import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";

export const RecevalCutoffTimeAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "330px" }}>
                    <DateTimePickerComponent
                        label='Receval Cutoff Time'
                        width='330px'
                        date={chargeBatchUpdate.recevalCutoffTime}
                        onDateChange={chargeDetailVM.onDatePickerChange}
                        fieldName={"recevalCutoffTime"} />
                </div>
            </div>

        </>
    )
}